import styled from '@emotion/styled'

import {NoStyleButton} from '@vio/atlas/helpers/NoStyleButton'
import {InputText} from '@vio/atlas/InputText'
import {ListItem} from '@vio/atlas/src/components/designSystem/ListItem'
import {cssTheme} from '@vio/atlas/themes'

type ListType = 'overlay' | 'popover'

/**
 * Input field
 */
// TODO: Migrate to Linaria after atlas migration
export const SearchFieldMobile = styled(InputText)`
  ::-webkit-search-cancel-button {
    display: none;
  }
  caret-color: ${cssTheme.colors.content.interactive.primary};
`

/**
 * Suggestions list
 */
export const SuggestionsListElement = styled.div`
  height: 100%;
  &.--is-overlay {
    overflow: scroll;
    padding-top: ${cssTheme.layout.spacing.s400};
  }
  &.--is-popover {
    padding: ${cssTheme.layout.spacing.s500} 0 ${cssTheme.layout.spacing.s400};
  }
`

export const SuggestionsListSection = styled.div<{listType: ListType}>`
  padding: ${({listType}) =>
      listType === 'popover' ? 0 : cssTheme.layout.spacing.s300}
    0;
`

export const SuggestionTextElement = styled.div`
  display: flex;
  justify-content: space-between;
  ${cssTheme.typography.labelS}

  em {
    font-style: normal;
    ${cssTheme.typography.labelS}
  }
`

export const SuggestionTextElementDetail = styled.div`
  ${cssTheme.typography.bodyS}
  color: ${cssTheme.colors.content.neutral.secondary};
`

export const UserHistoryHeadingElement = styled.h4`
  color: ${cssTheme.colors.content.neutral.secondary};
  ${cssTheme.typography.labelS}
  margin: 0;
  padding-block: 0 ${cssTheme.layout.spacing.s250};
  padding-inline: ${cssTheme.layout.spacing.s500} 0;
`

export const SuggestionTextWrapper = styled.div`
  flex: 2;
`

export const NearbySuggestionButton = styled(NoStyleButton)`
  width: 100%;
  :hover {
    background-color: ${cssTheme.colors.background.neutral.hover};
  }
`

// No Results Found
export const DestinationPickerNoResultsWrapper = styled.div<{
  listType: ListType
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: ${({listType}) =>
    listType === 'popover'
      ? cssTheme.layout.spacing.s400
      : cssTheme.layout.spacing.s950};
  margin-bottom: ${cssTheme.layout.spacing.s400};
  margin-right: ${cssTheme.layout.spacing.s400};
  margin-left: ${cssTheme.layout.spacing.s400};
`

export const StyledListItem = styled(ListItem)`
  &.--as-div {
    padding: 0 ${cssTheme.layout.spacing.s500};
  }
  &.--is-focused {
    background-color: ${cssTheme.colors.background.neutral.hover};
  }
`
